import { Injectable, OnDestroy } from "@angular/core";
import { MatPaginatorIntl } from "@angular/material/paginator";
import { TranslateService } from "@ngx-translate/core";
import { Subject, takeUntil } from "rxjs";

@Injectable()
export class TranslatedPaginatorIntl
  extends MatPaginatorIntl
  implements OnDestroy
{
  private readonly destroy$ = new Subject<void>();

  constructor(private readonly translate: TranslateService) {
    super();
    this.applyLabels();
    this.translate.onLangChange
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.applyLabels());
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  override getRangeLabel = (
    page: number,
    pageSize: number,
    length: number,
  ): string => {
    if (length === 0 || pageSize === 0) {
      return this.translate.instant("paginator.rangeEmpty", {
        length: 0,
      }) as string;
    }

    const total = Math.max(length, 0);
    const start = page * pageSize + 1;
    const end = Math.min(start + pageSize - 1, total);
    return this.translate.instant("paginator.range", {
      start,
      end,
      length: total,
    }) as string;
  };

  private applyLabels(): void {
    this.itemsPerPageLabel = this.translate.instant(
      "paginator.itemsPerPage",
    ) as string;
    this.nextPageLabel = this.translate.instant("paginator.nextPage") as string;
    this.previousPageLabel = this.translate.instant(
      "paginator.previousPage",
    ) as string;
    this.firstPageLabel = this.translate.instant(
      "paginator.firstPage",
    ) as string;
    this.lastPageLabel = this.translate.instant("paginator.lastPage") as string;
    this.changes.next();
  }
}
